
interface IProps {
  color?: string;
  size?: number;
}

export const FacebookSquare = ({size=45, color="#12121B"}: IProps) => (
  <svg width={size} height={size} viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={size} height={size} transform="translate(0.5)" fill={color}/>
    <path d="M24.5 24.5H27L28 20.5H24.5V18.5C24.5 17.47 24.5 16.5 26.5 16.5H28V13.14C27.674 13.097 26.443 13 25.143 13C22.428 13 20.5 14.657 20.5 17.7V20.5H17.5V24.5H20.5V33H24.5V24.5Z" fill="white"/>
  </svg>
)